import { render, staticRenderFns } from "./signUpResearcher.vue?vue&type=template&id=1e103304"
import script from "./signUpResearcher.vue?vue&type=script&lang=js"
export * from "./signUpResearcher.vue?vue&type=script&lang=js"
import style0 from "./signUpResearcher.vue?vue&type=style&index=0&id=1e103304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports